// extracted by mini-css-extract-plugin
export default {"melodyCardCategory":"G--z","categoryName":"H--z","categoryImage":"I--z","categoryContent":"J--z","bottomAligned":"K--z"};